const getIsLoggedIn = (authData) => !!authData?.signInUserSession?.idToken;

export default getIsLoggedIn;
